import * as React from 'react';
import { ISubMenuItem } from '../../../models/ISubMenuItem';

type UserInfoPopupSubMenuItemProps = {
    item: ISubMenuItem,
    selected: boolean,
    onSelect: (id: string) => void
}

class UserInfoPopupSubMenuItem extends React.Component<UserInfoPopupSubMenuItemProps> {
    onSelect = () => {
        const { item, onSelect } = this.props;
        onSelect(item.id);
    }

    render() {
        const { item, selected } = this.props;

        return <div
            className={`user-info_command user-info_sub-command font-size-popup_item ${selected && 'selected'}`}
            onClick={this.onSelect}>
            {item.title}
            {selected && <i className="user-info_command_checkmark icon icon-checkmark" />}
        </div>;
    }
}
export default UserInfoPopupSubMenuItem;